/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {_ROUTER_CONFIG as Éµngrx_modules_router_store_router_store_a,_createRouterConfig as Éµngrx_modules_router_store_router_store_b} from './src/router_store_module';